<template>
  <span :id="name">
    <slot />
    <b-tooltip :target="name" :disabled="!active" :placement="placement">
      {{ message }}
    </b-tooltip>
  </span>
</template>

<script>
export default {
  name: 'ItemWithTooltip',
  props: {
    name: String,
    active: Boolean,
    message: String,
    placement: {
      type: String,
      default: 'top',
    },
  },
};
</script>

<style scoped></style>
